import {FileListItem} from "../components/FileList";

/**
 * Maps raw `installedBaseNodeFiles` query results to {@link FileListItem}s.
 *
 * `userFilesCategory` is the already-resolved t("User files") label —
 * translation stays out of this pure function so it remains testable.
 * Files without a server-side access object stay visible but read-only
 * (the AssetFileManagement fallback).
 */
export const mapInstalledBaseNodeFiles = (files: any[], userFilesCategory: string): FileListItem[] =>
    (files ?? [])
        .filter(Boolean)
        .map((f: any) => ({
            id: f.id,
            fileId: f.file?.id ?? null,
            filename: f.filename,
            basename: f.file?.basename ?? '',
            extension: f.file?.extension ?? null,
            comment: f.comment ?? null,
            supportsComment: true,
            category: f.category ?? userFilesCategory,
            insert: f.insert ?? null,
            contentType: f.file?.contentType ?? '',
            size: f.file?.size ?? 0,
            link: f.file?.link ?? '',
            thumbnailLink: f.file?.thumbnailLink ?? null,
            previewLink: f.file?.previewLink ?? null,
            language: f.file?.language ?? null,
            access: f.access ?? {read: true, write: false, delete: false},
            kind: 'installedBaseNode' as const,
        }));

/**
 * Maps raw `productNodeFiles` query results to {@link FileListItem}s.
 * Product documents are always read-only and never carry a comment.
 */
export const mapProductNodeFiles = (files: any[]): FileListItem[] =>
    (files ?? [])
        .filter(Boolean)
        .map((f: any) => ({
            id: f.id,
            fileId: f.file?.id ?? null,
            filename: f.filename,
            basename: f.file?.basename ?? '',
            extension: f.file?.extension ?? null,
            comment: null,
            supportsComment: false,
            category: f.category ?? null,
            insert: f.insert ?? null,
            contentType: f.file?.contentType ?? '',
            size: f.file?.size ?? 0,
            link: f.file?.link ?? '',
            thumbnailLink: f.file?.thumbnailLink ?? null,
            previewLink: f.file?.previewLink ?? null,
            language: f.file?.language ?? null,
            access: {read: true, write: false, delete: false},
            kind: 'assetLocation' as const,
        }));
